// Full EN / OD (Odia) / HI (Hindi) translation dictionary for LSP website.
// Fallback: missing key in a non-EN lang falls back to EN.

const en = {
  meta: {
    site_name: "Loka Samabaya Pratisthan",
    tagline: "Natural Farming Trust · Odisha",
    home: {
      title: "Natural Farming Trust in Odisha | Loka Samabaya Pratisthan",
      desc: "Registered Trust in Odisha promoting natural farming, farmer training, indigenous seeds and sustainable rural development. Free training. 2,000+ farmers.",
      kw: "natural farming Odisha, farmer support Odisha, organic farming training Odisha, LSP Trust, indigenous seeds Odisha",
    },
    about: {
      title: "About LSP | NGO for Farmers & Rural Development, Odisha",
      desc: "Loka Samabaya Pratisthan is a registered Trust in Niali, Cuttack empowering farmers through natural farming, seed conservation and rural development.",
      kw: "NGO for farmers Odisha, rural development Odisha, farming trust Cuttack, Niali NGO, LSP about",
    },
    services: {
      title: "Our Work — Natural Farming & Seed Programs | LSP Odisha",
      desc: "Six core programs: natural farming advisory, indigenous seed conservation, organic inputs, farmer training, allied agriculture, rural marketing support.",
      kw: "natural farming services Odisha, indigenous seeds Odisha, organic inputs, rural marketing farmers",
    },
    training: {
      title: "Free Farming Training Odisha | Workshops for Farmers",
      desc: "Free, practical natural farming training in Odisha villages. Basic, intermediate and advanced modules. Join 2,000+ farmers across 6 districts.",
      kw: "farming training Odisha, organic farming workshops, free farmer training, natural farming course Cuttack",
    },
    products: {
      title: "Natural Farm Products | Rice, Pulses, Honey, Ghee — LSP Odisha",
      desc: "Chemical-free rice, pulses, vegetables, honey, A2 ghee and bio-inputs from LSP-supported natural farms. Bulk and retail orders across Odisha.",
      kw: "natural farm products Odisha, organic rice Odisha, A2 cow ghee Odisha, natural honey, bulk farm products",
    },
    gallery: {
      title: "Gallery — Farmer Training, Fields & Produce | LSP Odisha",
      desc: "Photos from LSP village training camps, farmer meetings, seed collections, natural farms and community outreach across Odisha.",
      kw: "farmer training photos, Odisha village farming, LSP gallery",
    },
    blog: {
      title: "Blog — Natural Farming Tips & Farmer Stories | LSP",
      desc: "Natural farming tips, indigenous seed guides, cost-saving techniques, and stories from farmers across Odisha.",
      kw: "natural farming blog Odisha, organic farming tips, farmer schemes India, seed saving guide",
    },
    contact: {
      title: "Contact Loka Samabaya Pratisthan | Niali, Cuttack, Odisha",
      desc: "Phone +91 99380 56120 · lspnaturalfarming@gmail.com · Niali, Cuttack, Bhubaneswar 751021, Odisha. Reach out for training, seeds, or partnerships.",
      kw: "contact LSP Odisha, natural farming Niali, farmer support Cuttack phone",
    },
  },
  nav: { home: "Home", about: "About", services: "Our Work", training: "Training", products: "Products", gallery: "Gallery", blog: "Blog", contact: "Contact", get_in_touch: "Get in Touch" },
  common: {
    call_us: "Call +91 99380 56120",
    read_more: "Read More",
    learn_more: "Learn More",
    explore: "Explore",
    enquire_now: "Enquire Now",
    send: "Send",
    sending: "Sending…",
    required_mark: "*",
    name: "Name",
    phone: "Phone",
    whatsapp: "WhatsApp Number",
    email: "Email",
    message: "Message",
    our_full_story: "Our full story",
    view_all_programs: "View all programs",
    all_articles: "All articles",
    voices: "Voices from the ground",
    loading: "Loading…",
  },
  hero: {
    eyebrow: "Registered Trust · Odisha, India",
    h1a: "Grow more.",
    h1b: "Spend less.",
    h1c: "Farm like your grandfather.",
    sub_before: "Loka Samabaya Pratisthan has helped",
    sub_bold: "2,000+ farmers across Odisha",
    sub_after: "cut chemical costs, revive their soil, and earn more — through natural farming, indigenous seeds, and free village-level training.",
    cta_call: "Call +91 99380 56120",
    cta_training: "Join Free Training",
    cta_work: "See Our Work",
    tagline: "Free for farmers · No fees · In your language · At your farm",
    scroll: "Scroll · Est. Odisha",
  },
  trust: {
    b1_label: "Registered Trust", b1_sub: "Under Indian Trust Act",
    b2_label: "2,000+ Farmers", b2_sub: "Across 6 districts",
    b3_label: "120+ Seed Varieties", b3_sub: "Preserved & shared free",
    b4_label: "Built by Farmers", b4_sub: "Led by our Chairman",
  },
  problem: {
    eyebrow: "The problem we face",
    h2a: "Farming in Odisha is",
    h2b: "harder than ever.",
    lead: "Every farmer we meet tells us the same four things:",
    p1_title: "Rising chemical costs", p1_text: "Fertilizer and pesticide bills eat up half of every harvest's income.",
    p2_title: "Soil is dying", p2_text: "Years of chemicals have left fields dry, hard, and lifeless.",
    p3_title: "Falling yields", p3_text: "Same land. Same work. Less crop — season after season.",
    p4_title: "No guidance", p4_text: "Nobody to ask. Nobody who speaks your language, in your village.",
    answer_eyebrow: "Our answer",
    answer: "Bring back the knowledge our grandfathers lived by — and pair it with modern, field-tested science.",
    learn_more: "How we do it",
  },
  how: {
    eyebrow: "How it works",
    h2a: "Three steps.",
    h2b: "No fees. No forms.",
    s1_title: "Call or visit us", s1_text: "One phone call to +91 99380 56120. No forms, no fees. We'll invite you to the nearest village camp.",
    s2_title: "Learn in your field", s2_text: "Hands-on training in your language — jeevamrut, composting, seed saving, crop planning. Not a classroom, your farm.",
    s3_title: "Grow naturally", s3_text: "Start with one plot. We stay with you through the season. Most farmers see results in the very first harvest.",
    cta_call: "Start with a call",
    note: "Talk to our coordinator in Odia, Hindi or English — whichever is easier for you.",
  },
  about_short: {
    eyebrow: "About the Trust",
    h2a: "A people's trust,",
    h2b: "not a company.",
    p1: "LSP is a registered Trust based in Niali, Cuttack. Our work is funded by well-wishers, our fields, and farmer cooperatives — not shareholders. Every rupee goes back to farmers, seeds, and training camps.",
    p2: "Healthy soil creates healthy food, healthy families, and a healthy nation.",
  },
  services_home: {
    eyebrow: "What we do",
    h2a: "Six quiet ways we",
    h2b: "change a village.",
    lead: "Every program is field-tested, farmer-led, and measured by the income a family keeps at season's end.",
    s1_title: "Natural Farming", s1_text: "Low-cost, chemical-free, eco-friendly systems that restore the land.",
    s2_title: "Indigenous Seeds", s2_text: "Conserving & distributing traditional rice, pulse, vegetable and oilseed varieties.",
    s3_title: "Farmer Training", s3_text: "Hands-on field workshops for farmers, students & rural institutions.",
    s4_title: "Allied Livelihood", s4_text: "Fishery, dairy, poultry, beekeeping — diversifying rural income.",
    s5_title: "Market Linkage", s5_text: "Connecting farmers directly to urban consumers and institutions.",
    s6_title: "Community Growth", s6_text: "Women's groups, rural youth, and village-level cooperatives.",
  },
  impact: {
    eyebrow: "Impact",
    h2a: "Growing change",
    h2b: "across Odisha.",
    i1: "Farmers supported",
    i2: "Indigenous seed varieties",
    i3: "Training camps / year",
    i4: "Districts reached",
    where_title: "We work shoulder-to-shoulder in:",
  },
  testimonials_home: {
    h2a: "What farmers",
    h2b: "tell us.",
    t1_q: "Chemical costs went down by half in the first season. My wife cried when she saw the savings.", t1_by: "Rajesh · Niali",
    t2_q: "LSP taught us that our grandfather's seeds are better than any company's. We are back to growing them.", t2_by: "Farmer Group · Cuttack",
    t3_q: "I was ready to leave farming. Natural farming gave me a reason to stay in my village.", t3_by: "Bhagaban · Dhenkanal",
    t4_q: "The training was free, and they stayed with us through the whole season. Who does that?", t4_by: "Sunita · Khordha",
    t5_q: "Our indigenous paddy sold at double the market rate in Bhubaneswar. LSP made that happen.", t5_by: "Farmer Collective · Bhubaneswar",
  },
  faq_home: {
    eyebrow: "Questions farmers ask",
    h2a: "Everything you want to know,",
    h2b: "plainly answered.",
    items: [
      { q: "What is Loka Samabaya Pratisthan?", a: "LSP is a registered Trust in Odisha promoting natural farming, indigenous seed preservation, farmer training, and rural livelihood development. We are based in Niali, Cuttack." },
      { q: "Is the training free for farmers?", a: "Yes. All village-level training camps and field demonstrations are completely free for farmers. Paid professional modules exist for institutions and urban learners." },
      { q: "Can I get indigenous seeds from LSP?", a: "Yes — subject to availability. We share traditional rice, pulse, vegetable and oilseed varieties with farmers who commit to growing and sharing them back to the seed bank." },
      { q: "In which districts does LSP work?", a: "We actively work in Niali, Cuttack, Bhubaneswar, Khordha, Dhenkanal, and nearby rural regions. We are expanding village by village." },
      { q: "How do I join a training program?", a: "Simply call +91 99380 56120 or send us a message on WhatsApp. We'll add you to the next batch in your region." },
      { q: "Will natural farming reduce my income in the first year?", a: "Most farmers see chemical costs drop by 50-70% from season one. Yields often stabilize within 2 seasons as soil recovers. We accompany you through the transition." },
    ],
  },
  final_cta: {
    h2a: "Your farm deserves",
    h2b: "a better season.",
    lead: "Call us. Visit a camp. Bring a friend. The first step is free — and it changes everything.",
    cta_call: "Call +91 99380 56120",
    cta_msg: "Send a message",
    cta_train: "Join training",
  },
  footer: {
    eyebrow: "Registered Trust",
    line1: "Est. for Farmers of Odisha",
    about: "Reviving traditional farming wisdom. Preserving indigenous seeds. Training the next generation of farmers across rural Odisha.",
    explore: "Explore",
    get_in_touch: "Get in touch",
    credit: "Built & Managed by",
    admin: "Admin",
    rights: "All rights reserved.",
  },
  about_page: {
    eyebrow: "About the Trust",
    h1a: "About Loka",
    h1b: "Samabaya Pratisthan.",
    intro: "A registered Trust under the Indian Trust Act, based in Odisha, committed to transforming agriculture through natural farming, farmer education, indigenous seed protection, and sustainable livelihoods.",
    quote: "\"Healthy soil creates healthy food, healthy families, and a healthy nation.\"",
    quote_by: "— LSP Founding Principle",
    vision_eyebrow: "Our Vision",
    vision_text: "Prosperous, self-reliant rural communities built on traditional wisdom.",
    mission_eyebrow: "Our Mission",
    m1: "Promote natural farming across Odisha",
    m2: "Reduce chemical fertilizer & pesticide dependency",
    m3: "Protect native seed diversity",
    m4: "Improve farmer income",
    m5: "Train rural youth in agriculture",
    m6: "Support women in farming communities",
    values_eyebrow: "Our Values",
    values_h2: "Non-negotiables.",
    v1_title: "Sustainability", v1_text: "Every practice must outlast us by a hundred seasons.",
    v2_title: "Farmer First", v2_text: "Decisions made in farmer fields, not boardrooms.",
    v3_title: "Community Growth", v3_text: "We succeed when a village succeeds — together.",
    v4_title: "Transparency", v4_text: "Open records, open fields, open conversations.",
    v5_title: "Soil Health", v5_text: "Healthy soil is the foundation of healthy nations.",
    serves_eyebrow: "Whom we serve",
    serves_h2: "The people behind every harvest.",
    serves: ["Small Farmers", "Marginal Farmers", "Sharecroppers", "Women Farmers", "Rural Youth", "Farmer Groups"],
  },
  services_page: {
    eyebrow: "Our Work · Services",
    h1a: "Our services &",
    h1b: "core activities.",
    intro: "Six interlinked programs designed to rebuild rural economies from the soil up — every activity is field-tested with the farmers we serve.",
    blocks: [
      { title: "Natural Farming Advisory", points: ["Soil restoration", "Chemical-free farming", "Mulching methods", "Crop diversity", "Low-input cultivation"] },
      { title: "Indigenous Seed Conservation", intro: "Traditional varieties suited to local climate and better nutrition.", points: ["Rice seeds", "Pulses", "Vegetables", "Oil seeds"] },
      { title: "Organic Inputs & Natural Formulations", points: ["Jeevamrut", "Compost", "Vermicompost", "Liquid manure", "Natural pest repellents"] },
      { title: "Farmer Capacity Building", points: ["Village training camps", "Demonstration plots", "Exposure visits", "Seasonal guidance"] },
      { title: "Allied Agriculture Programs", intro: "Diversifying income beyond the paddy season.", points: ["Dairy farming", "Poultry farming", "Fish farming", "Beekeeping"] },
      { title: "Rural Marketing Support", points: ["Direct-to-consumer", "Urban buyer networks", "Cooperative branding", "Institutional supply"] },
    ],
    cta: "Want us to work with your village or institution?",
    cta_btn: "Let's talk",
  },
  training_page: {
    eyebrow: "Training Programs",
    h1a: "Natural farming",
    h1b: "training in Odisha.",
    intro: "Practical, field-based modules — from beginner basics to running a profitable natural farm.",
    l1_tag: "Basic", l1_title: "Foundations of Natural Farming",
    l1_topics: ["Soil health basics", "Seed treatment", "Composting", "Intro to Jeevamrut"],
    l2_tag: "Intermediate", l2_title: "Managing a Natural Farm",
    l2_topics: ["Pest control naturally", "Crop planning", "Water management", "Mulching & mixed cropping"],
    l3_tag: "Advanced", l3_title: "Natural Farm as a Business",
    l3_topics: ["Farm business model", "Value addition", "Direct selling methods", "Certification & branding"],
    who_eyebrow: "Who can attend",
    who_h2a: "For anyone ready to",
    who_h2b: "work with the land.",
    audience: ["Farmers", "Agriculture students", "NGOs & Institutions", "Rural entrepreneurs", "Youth stepping into farming", "Govt. extension workers"],
    modes_eyebrow: "Training modes",
    modes_h2a: "Where it all",
    modes_h2b: "happens.",
    modes: ["On-field training", "Group workshops", "Institutional sessions", "Paid professional modules"],
    cta_title: "Book a training session today.",
    cta_btn: "Request a slot",
  },
  products_page: {
    eyebrow: "Natural farm products",
    h1a: "From our fields",
    h1b: "to your kitchen.",
    intro: "Value-added produce from LSP-supported farms. Available for retail and institutional bulk orders.",
    items: [
      { name: "Indigenous Rice", tag: "Staple", desc: "Traditional Odisha varieties — rich in nutrition and grown without chemicals." },
      { name: "Pulses", tag: "Protein", desc: "Toor, moong, urad & kulthi from rotational natural farms." },
      { name: "Seasonal Vegetables", tag: "Fresh", desc: "Field-harvested, season-aligned, zero residue." },
      { name: "Wild Honey", tag: "Apiary", desc: "Multi-floral honey from LSP beekeeper groups." },
      { name: "A2 Cow Ghee", tag: "Dairy", desc: "Slow-churned, traditional bilona method, desi cow." },
      { name: "Fresh Fish", tag: "Fishery", desc: "From LSP-supported natural fish farms." },
      { name: "Jeevamrut & Bio Inputs", tag: "Bio-input", desc: "On-farm prepared biostimulants — ready to use." },
      { name: "Solid & Liquid Manure", tag: "Soil", desc: "Compost & vermicompost for soil rebuilding." },
    ],
    bulk_eyebrow: "Bulk & Institutional",
    bulk_title: "Supplying hostels, cafes, and urban stores across Odisha.",
    enquire_dialog_title: "Enquire about",
    enquire_dialog_desc: "Share your details — our team will reach out on WhatsApp or phone.",
  },
  gallery_page: {
    eyebrow: "Gallery",
    h1a: "Field notes,",
    h1b: "in pictures.",
    intro: "Training camps, farmer meetings, seed collections, our fields, the produce, and the community that makes it all possible.",
  },
  blog_page: {
    eyebrow: "Journal · Field Notes",
    h1a: "Stories from",
    h1b: "the field.",
    empty: "No posts yet. Check back soon.",
  },
  contact_page: {
    eyebrow: "Get in touch",
    h1a: "Let's talk",
    h1b: "farming.",
    chairman_label: "Chairman",
    chairman_name: "Subas Chandra Sahu",
    phone_label: "Phone",
    email_label: "Email",
    address_label: "Address",
    address: "Niali, Cuttack\nBhubaneswar — 751021\nOdisha, India",
    form_title: "Send us a message.",
    form_sub: "We usually respond within 24 hours.",
    form_success: "Message sent. We'll be in touch soon!",
    form_error_required: "Name, phone and message are required",
  },
};

const or = {
  meta: {
    site_name: "ଲୋକ ସମବାୟ ପ୍ରତିଷ୍ଠାନ",
    tagline: "ପ୍ରାକୃତିକ କୃଷି ଟ୍ରଷ୍ଟ · ଓଡ଼ିଶା",
    home: {
      title: "ଓଡ଼ିଶାର ପ୍ରାକୃତିକ କୃଷି ଟ୍ରଷ୍ଟ | ଲୋକ ସମବାୟ ପ୍ରତିଷ୍ଠାନ",
      desc: "ଓଡ଼ିଶାର ପଞ୍ଜୀକୃତ ଟ୍ରଷ୍ଟ — ପ୍ରାକୃତିକ କୃଷି, କୃଷକ ପ୍ରଶିକ୍ଷଣ, ସ୍ଥାନୀୟ ବିହନ ଏବଂ ଗ୍ରାମୀଣ ବିକାଶ। ମାଗଣା ପ୍ରଶିକ୍ଷଣ। ୨,୦୦୦+ କୃଷକ।",
      kw: "ଓଡ଼ିଶାରେ ପ୍ରାକୃତିକ କୃଷି, ଓଡ଼ିଶା କୃଷକ ସହଯୋଗ, ଜୈବିକ କୃଷି ପ୍ରଶିକ୍ଷଣ, LSP ଟ୍ରଷ୍ଟ",
    },
    about: {
      title: "LSP ବିଷୟରେ | ଓଡ଼ିଶାର କୃଷକ ଓ ଗ୍ରାମୀଣ ବିକାଶ ଏନଜିଓ",
      desc: "ଲୋକ ସମବାୟ ପ୍ରତିଷ୍ଠାନ ହେଉଛି କଟକର ନିଆଳିର ଏକ ପଞ୍ଜୀକୃତ ଟ୍ରଷ୍ଟ, ପ୍ରାକୃତିକ କୃଷି ଓ ବିହନ ସଂରକ୍ଷଣ ଦ୍ୱାରା କୃଷକମାନଙ୍କୁ ସଶକ୍ତ କରୁଛି।",
      kw: "ଓଡ଼ିଶାର କୃଷକ ଏନଜିଓ, ଗ୍ରାମୀଣ ବିକାଶ, କଟକ କୃଷି ଟ୍ରଷ୍ଟ, ନିଆଳି ଏନଜିଓ",
    },
    services: { title: "ଆମର କାର୍ଯ୍ୟ — ପ୍ରାକୃତିକ କୃଷି ଓ ବିହନ ଯୋଜନା | LSP ଓଡ଼ିଶା", desc: "ଛଅଟି ମୂଳ ଯୋଜନା — ପ୍ରାକୃତିକ କୃଷି ସଲାହ, ସ୍ଥାନୀୟ ବିହନ ସଂରକ୍ଷଣ, ଜୈବିକ ଇନପୁଟ୍, କୃଷକ ପ୍ରଶିକ୍ଷଣ, ସହାୟକ କୃଷି ଓ ଗ୍ରାମୀଣ ବଜାର।", kw: "ଓଡ଼ିଶା ପ୍ରାକୃତିକ କୃଷି ସେବା, ସ୍ଥାନୀୟ ବିହନ, ଜୈବିକ ଇନପୁଟ୍" },
    training: { title: "ଓଡ଼ିଶାରେ ମାଗଣା କୃଷି ପ୍ରଶିକ୍ଷଣ | କୃଷକ କର୍ମଶାଳା", desc: "ଓଡ଼ିଶା ଗାଁମାନଙ୍କରେ ମାଗଣା, ବ୍ୟାବହାରିକ ପ୍ରାକୃତିକ କୃଷି ପ୍ରଶିକ୍ଷଣ। ପ୍ରାଥମିକ, ମଧ୍ୟମ ଓ ଉନ୍ନତ ମଡ୍ୟୁଲ୍।", kw: "ଓଡ଼ିଶା କୃଷି ପ୍ରଶିକ୍ଷଣ, ଜୈବିକ କୃଷି କର୍ମଶାଳା, ମାଗଣା କୃଷକ ତାଲିମ" },
    products: { title: "ପ୍ରାକୃତିକ କୃଷି ଉତ୍ପାଦ | ଚାଉଳ, ଡାଲି, ମହୁ, ଘିଅ — LSP ଓଡ଼ିଶା", desc: "LSP ସମର୍ଥିତ ପ୍ରାକୃତିକ କୃଷିରୁ ରାସାୟନିକ-ମୁକ୍ତ ଚାଉଳ, ଡାଲି, ପନିପରିବା, ମହୁ, A2 ଘିଅ ଓ ଜୈବିକ ଇନପୁଟ୍।", kw: "ଓଡ଼ିଶା ପ୍ରାକୃତିକ ଉତ୍ପାଦ, ଜୈବିକ ଚାଉଳ, A2 ଗୋ ଘିଅ" },
    gallery: { title: "ଗ୍ୟାଲେରୀ — କୃଷକ ପ୍ରଶିକ୍ଷଣ ଓ କ୍ଷେତ୍ର | LSP ଓଡ଼ିଶା", desc: "LSP ଗାଁ ଶିବିର, କୃଷକ ସଭା, ବିହନ ସଂଗ୍ରହ ଓ ପ୍ରାକୃତିକ କୃଷିର ଫଟୋ।", kw: "କୃଷକ ପ୍ରଶିକ୍ଷଣ ଫଟୋ, ଓଡ଼ିଶା ଗାଁ କୃଷି" },
    blog: { title: "ବ୍ଲଗ୍ — ପ୍ରାକୃତିକ କୃଷି ଟିପ୍ସ ଓ କୃଷକ କାହାଣୀ | LSP", desc: "ପ୍ରାକୃତିକ କୃଷି ଟିପ୍ସ, ସ୍ଥାନୀୟ ବିହନ ଗାଇଡ୍, ଖର୍ଚ୍ଚ ବଞ୍ଚାଇବା ଓ ଓଡ଼ିଶା କୃଷକ କାହାଣୀ।", kw: "ଓଡ଼ିଶା ପ୍ରାକୃତିକ କୃଷି ବ୍ଲଗ୍" },
    contact: { title: "ଲୋକ ସମବାୟ ପ୍ରତିଷ୍ଠାନ ସହ ଯୋଗାଯୋଗ | ନିଆଳି, କଟକ", desc: "ଫୋନ୍ +91 99380 56120 · ନିଆଳି, କଟକ, ଓଡ଼ିଶା।", kw: "LSP ଓଡ଼ିଶା ଯୋଗାଯୋଗ" },
  },
  nav: { home: "ମୁଖ୍ୟ", about: "ଆମ ବିଷୟରେ", services: "ଆମର କାର୍ଯ୍ୟ", training: "ପ୍ରଶିକ୍ଷଣ", products: "ଉତ୍ପାଦ", gallery: "ଗ୍ୟାଲେରୀ", blog: "ବ୍ଲଗ୍", contact: "ଯୋଗାଯୋଗ", get_in_touch: "ଯୋଗାଯୋଗ କରନ୍ତୁ" },
  common: {
    call_us: "+91 99380 56120 ଡାକନ୍ତୁ",
    read_more: "ଅଧିକ ପଢ଼ନ୍ତୁ", learn_more: "ଅଧିକ ଜାଣନ୍ତୁ", explore: "ଦେଖନ୍ତୁ",
    enquire_now: "ଅନୁସନ୍ଧାନ କରନ୍ତୁ",
    send: "ପଠାନ୍ତୁ", sending: "ପଠାଯାଉଛି…",
    name: "ନାମ", phone: "ଫୋନ୍", whatsapp: "ହ୍ୱାଟ୍ସଆପ୍ ନମ୍ବର", email: "ଇମେଲ୍", message: "ବାର୍ତ୍ତା",
    our_full_story: "ଆମର ପୂର୍ଣ୍ଣ କାହାଣୀ",
    view_all_programs: "ସମସ୍ତ ଯୋଜନା ଦେଖନ୍ତୁ",
    all_articles: "ସମସ୍ତ ଆର୍ଟିକଲ୍",
    voices: "କ୍ଷେତ୍ରରୁ ସ୍ୱର",
    loading: "ଲୋଡ୍ ହେଉଛି…",
  },
  hero: {
    eyebrow: "ପଞ୍ଜୀକୃତ ଟ୍ରଷ୍ଟ · ଓଡ଼ିଶା, ଭାରତ",
    h1a: "ଅଧିକ ଫସଲ।",
    h1b: "କମ୍ ଖର୍ଚ୍ଚ।",
    h1c: "ଆପଣଙ୍କ ଜେଜେବାପାଙ୍କ ପରି ଚାଷ କରନ୍ତୁ।",
    sub_before: "ଲୋକ ସମବାୟ ପ୍ରତିଷ୍ଠାନ",
    sub_bold: "ଓଡ଼ିଶାର ୨,୦୦୦+ କୃଷକଙ୍କୁ",
    sub_after: "ରାସାୟନିକ ଖର୍ଚ୍ଚ କମେଇବା, ମାଟି ସୁସ୍ଥ କରିବା ଓ ଅଧିକ ରୋଜଗାର କରିବାରେ ସାହାଯ୍ୟ କରିଛି — ପ୍ରାକୃତିକ କୃଷି, ସ୍ଥାନୀୟ ବିହନ ଓ ମାଗଣା ଗାଁ ସ୍ତରୀୟ ପ୍ରଶିକ୍ଷଣ ମାଧ୍ୟମରେ।",
    cta_call: "+91 99380 56120 ଡାକନ୍ତୁ",
    cta_training: "ମାଗଣା ପ୍ରଶିକ୍ଷଣରେ ଯୋଗ ଦିଅନ୍ତୁ",
    cta_work: "ଆମର କାର୍ଯ୍ୟ ଦେଖନ୍ତୁ",
    tagline: "କୃଷକଙ୍କ ପାଇଁ ମାଗଣା · କୌଣସି ଫି ନାହିଁ · ଆପଣଙ୍କ ଭାଷାରେ · ଆପଣଙ୍କ କ୍ଷେତ୍ରରେ",
    scroll: "ସ୍କ୍ରଲ୍ · ଓଡ଼ିଶା",
  },
  trust: {
    b1_label: "ପଞ୍ଜୀକୃତ ଟ୍ରଷ୍ଟ", b1_sub: "ଭାରତୀୟ ଟ୍ରଷ୍ଟ ଆକ୍ଟ ଅଧୀନରେ",
    b2_label: "୨,୦୦୦+ କୃଷକ", b2_sub: "୬ଟି ଜିଲ୍ଲାରେ",
    b3_label: "୧୨୦+ ବିହନ ପ୍ରକାର", b3_sub: "ସଂରକ୍ଷିତ ଓ ମାଗଣା ବଣ୍ଟନ",
    b4_label: "କୃଷକଙ୍କ ଦ୍ୱାରା ନିର୍ମିତ", b4_sub: "ଆମ ଅଧ୍ୟକ୍ଷଙ୍କ ନେତୃତ୍ୱରେ",
  },
  problem: {
    eyebrow: "ଆମେ ଭୋଗୁଥିବା ସମସ୍ୟା",
    h2a: "ଓଡ଼ିଶାରେ ଚାଷ ଏବେ",
    h2b: "ପୂର୍ବ ଅପେକ୍ଷା କଠିନ।",
    lead: "ଆମେ ଭେଟୁଥିବା ପ୍ରତ୍ୟେକ କୃଷକ ଏହି ଚାରିଟି କଥା କୁହନ୍ତି:",
    p1_title: "ରାସାୟନିକ ଖର୍ଚ୍ଚ ବଢୁଛି", p1_text: "ସାର ଓ କୀଟନାଶକର ବିଲ୍ ପ୍ରତ୍ୟେକ ଅମଳର ଅଧା ଆୟ ଖାଇଯାଉଛି।",
    p2_title: "ମାଟି ମରୁଛି", p2_text: "ବର୍ଷ ବର୍ଷର ରାସାୟନିକ ବ୍ୟବହାର କ୍ଷେତ୍ରକୁ ଶୁଖିଲା ଓ ମୃତ କରିଦେଇଛି।",
    p3_title: "ଫସଲ କମୁଛି", p3_text: "ସମାନ ଜମି। ସମାନ ପରିଶ୍ରମ। କମ୍ ଫସଲ — ଋତୁ ପରେ ଋତୁ।",
    p4_title: "କୌଣସି ମାର୍ଗଦର୍ଶନ ନାହିଁ", p4_text: "ପଚାରିବାକୁ କେହି ନାହାଁନ୍ତି। ଆପଣଙ୍କ ଭାଷା କୁହନ୍ତି ଏହି ପରି କେହି ନାହାଁନ୍ତି।",
    answer_eyebrow: "ଆମର ସମାଧାନ",
    answer: "ଆମ ଜେଜେବାପାମାନେ ବ୍ୟବହାର କରୁଥିବା ଜ୍ଞାନକୁ ଫେରାଇ ଆଣିବା — ଏବଂ ଆଧୁନିକ, କ୍ଷେତ୍ର-ପରୀକ୍ଷିତ ବିଜ୍ଞାନ ସହ ମିଶାଇବା।",
    learn_more: "ଆମେ କିପରି କରୁ",
  },
  how: {
    eyebrow: "କିପରି କାମ କରେ",
    h2a: "ତିନୋଟି ପାହାଚ।",
    h2b: "କୌଣସି ଫି ନାହିଁ। କୌଣସି ଫର୍ମ ନାହିଁ।",
    s1_title: "ଡାକନ୍ତୁ କିମ୍ବା ଆସନ୍ତୁ", s1_text: "+91 99380 56120 କୁ ଗୋଟିଏ ଫୋନ୍। କୌଣସି ଫର୍ମ, କୌଣସି ଫି ନାହିଁ। ଆମେ ଆପଣଙ୍କ ନିକଟତମ ଗାଁ ଶିବିରକୁ ଡାକିବୁ।",
    s2_title: "ନିଜ କ୍ଷେତ୍ରରେ ଶିଖନ୍ତୁ", s2_text: "ଆପଣଙ୍କ ଭାଷାରେ ହାତେ-ହାତ ପ୍ରଶିକ୍ଷଣ — ଜୀବାମୃତ, କମ୍ପୋଷ୍ଟିଂ, ବିହନ ସଞ୍ଚୟ, ଫସଲ ଯୋଜନା। କ୍ଲାସ୍ରୁମ୍ ନୁହେଁ, ଆପଣଙ୍କ କ୍ଷେତ୍ର।",
    s3_title: "ପ୍ରାକୃତିକ ଭାବେ ଚାଷ କରନ୍ତୁ", s3_text: "ଗୋଟିଏ ପ୍ଲଟ୍ରୁ ଆରମ୍ଭ କରନ୍ତୁ। ଆମେ ଋତୁ ଯାଏଁ ଆପଣଙ୍କ ସହ ରହିବୁ। ଅଧିକାଂଶ କୃଷକ ପ୍ରଥମ ଅମଳରେ ଫଳାଫଳ ଦେଖନ୍ତି।",
    cta_call: "ଗୋଟିଏ ଫୋନ୍ ଦେଇ ଆରମ୍ଭ କରନ୍ତୁ",
    note: "ଓଡ଼ିଆ, ହିନ୍ଦୀ କିମ୍ବା ଇଂରାଜୀରେ ଆମ କୋ-ଅର୍ଡିନେଟରଙ୍କ ସହ କଥା ହୁଅନ୍ତୁ — ଯାହା ଆପଣଙ୍କୁ ସହଜ ଲାଗୁଥାଏ।",
  },
  about_short: {
    eyebrow: "ଟ୍ରଷ୍ଟ ବିଷୟରେ",
    h2a: "ଏକ ଜନତାଙ୍କ ଟ୍ରଷ୍ଟ,",
    h2b: "କମ୍ପାନୀ ନୁହେଁ।",
    p1: "LSP ନିଆଳି, କଟକରେ ଆଧାରିତ ଏକ ପଞ୍ଜୀକୃତ ଟ୍ରଷ୍ଟ। ଆମର କାର୍ଯ୍ୟ ଶୁଭେଚ୍ଛୁ, ଆମର କ୍ଷେତ୍ର ଓ କୃଷକ ସମବାୟ ଦ୍ୱାରା ପୋଷିତ — ଶେୟାରଧାରକ ଦ୍ୱାରା ନୁହେଁ। ପ୍ରତ୍ୟେକ ଟଙ୍କା କୃଷକ, ବିହନ ଓ ପ୍ରଶିକ୍ଷଣ ଶିବିରକୁ ଫେରିଯାଏ।",
    p2: "ସୁସ୍ଥ ମାଟି ସୁସ୍ଥ ଖାଦ୍ୟ, ସୁସ୍ଥ ପରିବାର ଓ ସୁସ୍ଥ ଦେଶ ସୃଷ୍ଟି କରେ।",
  },
  services_home: {
    eyebrow: "ଆମେ କ'ଣ କରୁ",
    h2a: "ଆମେ ଗୋଟିଏ ଗାଁକୁ",
    h2b: "ବଦଳାଇବାର ଛଅ ଉପାୟ।",
    lead: "ପ୍ରତ୍ୟେକ ଯୋଜନା କ୍ଷେତ୍ର-ପରୀକ୍ଷିତ, କୃଷକ-ନେତୃତ୍ୱାଧୀନ, ଏବଂ ଋତୁ ଶେଷରେ ପରିବାର ରଖୁଥିବା ଆୟ ଦ୍ୱାରା ମପାଯାଏ।",
    s1_title: "ପ୍ରାକୃତିକ କୃଷି", s1_text: "କମ୍ ଖର୍ଚ୍ଚ, ରାସାୟନିକ-ମୁକ୍ତ, ପରିବେଶ-ଅନୁକୂଳ ପ୍ରଣାଳୀ ଯାହା ଜମିକୁ ପୁନଃସ୍ଥାପନ କରେ।",
    s2_title: "ସ୍ଥାନୀୟ ବିହନ", s2_text: "ପାରମ୍ପରିକ ଚାଉଳ, ଡାଲି, ପନିପରିବା ଓ ତେଲ ବିହନ ସଂରକ୍ଷଣ ଓ ବଣ୍ଟନ।",
    s3_title: "କୃଷକ ପ୍ରଶିକ୍ଷଣ", s3_text: "କୃଷକ, ଛାତ୍ର ଓ ଗ୍ରାମୀଣ ସଂସ୍ଥା ପାଇଁ ହାତେ-ହାତ କ୍ଷେତ୍ର କର୍ମଶାଳା।",
    s4_title: "ସହାୟକ ଜୀବିକା", s4_text: "ମତ୍ସ୍ୟ, ଦୁଗ୍ଧ, କୁକୁଡ଼ା, ମହୁମାଛି ପାଳନ — ଗ୍ରାମୀଣ ଆୟ ବିବିଧୀକରଣ।",
    s5_title: "ବଜାର ସଂଯୋଗ", s5_text: "କୃଷକଙ୍କୁ ସିଧାସଳଖ ସହରର ଗ୍ରାହକ ଓ ସଂସ୍ଥା ସହ ଯୋଡ଼ିବା।",
    s6_title: "ସମୁଦାୟ ଅଭିବୃଦ୍ଧି", s6_text: "ମହିଳା ଗୋଷ୍ଠୀ, ଗ୍ରାମୀଣ ଯୁବକ ଓ ଗାଁ ସ୍ତରୀୟ ସମବାୟ।",
  },
  impact: {
    eyebrow: "ପ୍ରଭାବ",
    h2a: "ବଢୁଥିବା ପରିବର୍ତ୍ତନ",
    h2b: "ସାରା ଓଡ଼ିଶାରେ।",
    i1: "ସମର୍ଥିତ କୃଷକ",
    i2: "ସ୍ଥାନୀୟ ବିହନ ପ୍ରକାର",
    i3: "ବର୍ଷକୁ ପ୍ରଶିକ୍ଷଣ ଶିବିର",
    i4: "ପହଁଚିଥିବା ଜିଲ୍ଲା",
    where_title: "ଆମେ ଏମାନଙ୍କ ସହ କାନ୍ଧକୁ କାନ୍ଧ ମିଶାଇ କାମ କରୁ:",
  },
  testimonials_home: {
    h2a: "କୃଷକମାନେ ଆମକୁ",
    h2b: "କ'ଣ କୁହନ୍ତି।",
    t1_q: "ପ୍ରଥମ ଋତୁରେ ରାସାୟନିକ ଖର୍ଚ୍ଚ ଅଧା ହୋଇଗଲା। ବଞ୍ଚତ ଦେଖି ମୋ ସ୍ତ୍ରୀ କାନ୍ଦିଲା।", t1_by: "ରାଜେଶ · ନିଆଳି",
    t2_q: "LSP ଶିଖାଇଲା ଯେ ଆମ ଜେଜେବାପାଙ୍କ ବିହନ କମ୍ପାନୀ ବିହନଠାରୁ ଭଲ। ଆମେ ସେଗୁଡ଼ିକ ଚାଷ କରୁଛୁ।", t2_by: "କୃଷକ ଗୋଷ୍ଠୀ · କଟକ",
    t3_q: "ମୁଁ ଚାଷ ଛାଡିବାକୁ ପ୍ରସ୍ତୁତ ଥିଲି। ପ୍ରାକୃତିକ କୃଷି ମୋ ଗାଁରେ ରହିବାର କାରଣ ଦେଲା।", t3_by: "ଭଗବାନ · ଢେଙ୍କାନାଳ",
    t4_q: "ପ୍ରଶିକ୍ଷଣ ମାଗଣା ଥିଲା, ଏବଂ ସେମାନେ ଋତୁ ଯାଏଁ ଆମ ସହ ରହିଲେ। କିଏ ଏହିପରି କରନ୍ତି?", t4_by: "ସୁନୀତା · ଖୋର୍ଦ୍ଧା",
    t5_q: "ଆମର ସ୍ଥାନୀୟ ଧାନ ଭୁବନେଶ୍ୱରରେ ଦ୍ୱିଗୁଣ ମୂଲ୍ୟରେ ବିକ୍ରି ହେଲା। LSP ଏହା ସମ୍ଭବ କଲା।", t5_by: "କୃଷକ ସମବାୟ · ଭୁବନେଶ୍ୱର",
  },
  faq_home: {
    eyebrow: "କୃଷକ ପଚାରୁଥିବା ପ୍ରଶ୍ନ",
    h2a: "ଆପଣ ଜାଣିବାକୁ ଚାହୁଁଥିବା ସବୁକିଛି,",
    h2b: "ସରଳ ଭାବରେ ଉତ୍ତର।",
    items: [
      { q: "ଲୋକ ସମବାୟ ପ୍ରତିଷ୍ଠାନ କଣ?", a: "LSP ଓଡ଼ିଶାର ଏକ ପଞ୍ଜୀକୃତ ଟ୍ରଷ୍ଟ, ପ୍ରାକୃତିକ କୃଷି, ସ୍ଥାନୀୟ ବିହନ ସଂରକ୍ଷଣ, କୃଷକ ପ୍ରଶିକ୍ଷଣ ଓ ଗ୍ରାମୀଣ ଜୀବିକା ବିକାଶକୁ ପ୍ରୋତ୍ସାହନ ଦେଉଛି। ଆମେ ନିଆଳି, କଟକରେ ଆଧାରିତ।" },
      { q: "କୃଷକଙ୍କ ପାଇଁ ପ୍ରଶିକ୍ଷଣ ମାଗଣା କି?", a: "ହଁ। ସମସ୍ତ ଗାଁ ସ୍ତରୀୟ ପ୍ରଶିକ୍ଷଣ ଶିବିର ଓ କ୍ଷେତ୍ର ଦର୍ଶନ କୃଷକଙ୍କ ପାଇଁ ସମ୍ପୂର୍ଣ୍ଣ ମାଗଣା। ପେଶାଦାର ମଡ୍ୟୁଲ୍ ସଂସ୍ଥା ପାଇଁ ଦରକାର।" },
      { q: "ମୁଁ LSPରୁ ସ୍ଥାନୀୟ ବିହନ ପାଇ ପାରିବି କି?", a: "ହଁ — ଉପଲବ୍ଧତା ଉପରେ ନିର୍ଭର କରି। ଆମେ ପାରମ୍ପରିକ ଚାଉଳ, ଡାଲି, ପନିପରିବା ଓ ତେଲ ବିହନ କୃଷକମାନଙ୍କ ସହ ଭାଗ କରୁଛୁ।" },
      { q: "LSP କେଉଁ ଜିଲ୍ଲାରେ କାମ କରେ?", a: "ଆମେ ନିଆଳି, କଟକ, ଭୁବନେଶ୍ୱର, ଖୋର୍ଦ୍ଧା, ଢେଙ୍କାନାଳ ଓ ନିକଟବର୍ତ୍ତୀ ଗ୍ରାମୀଣ ଅଞ୍ଚଳରେ ସକ୍ରିୟ ଭାବେ କାମ କରୁଛୁ।" },
      { q: "ମୁଁ କିପରି ପ୍ରଶିକ୍ଷଣ କାର୍ଯ୍ୟକ୍ରମରେ ଯୋଗ ଦେବି?", a: "କେବଳ +91 99380 56120 ଡାକନ୍ତୁ କିମ୍ବା ହ୍ୱାଟ୍ସଆପ୍ରେ ବାର୍ତ୍ତା ପଠାନ୍ତୁ। ଆମେ ଆପଣଙ୍କୁ ପରବର୍ତ୍ତୀ ବ୍ୟାଚ୍ରେ ଯୋଡ଼ିବୁ।" },
      { q: "ପ୍ରାକୃତିକ କୃଷି ପ୍ରଥମ ବର୍ଷରେ ମୋ ଆୟ କମାଇବ କି?", a: "ଅଧିକାଂଶ କୃଷକ ପ୍ରଥମ ଋତୁରୁ ରାସାୟନିକ ଖର୍ଚ୍ଚ ୫୦-୭୦% କମିଥିବାର ଦେଖନ୍ତି। ଆମେ ପୁରା ଯାତ୍ରାରେ ଆପଣଙ୍କ ସହ ରହୁ।" },
    ],
  },
  final_cta: {
    h2a: "ଆପଣଙ୍କ କ୍ଷେତ୍ର ପାଇବା ଯୋଗ୍ୟ",
    h2b: "ଏକ ଉତ୍ତମ ଋତୁ।",
    lead: "ଆମକୁ ଡାକନ୍ତୁ। ଶିବିରକୁ ଆସନ୍ତୁ। ବନ୍ଧୁଙ୍କୁ ଆଣନ୍ତୁ। ପ୍ରଥମ ପାହାଚ ମାଗଣା — ଏବଂ ଏହା ସବୁକିଛି ବଦଳାଇଦିଏ।",
    cta_call: "+91 99380 56120 ଡାକନ୍ତୁ",
    cta_msg: "ବାର୍ତ୍ତା ପଠାନ୍ତୁ",
    cta_train: "ପ୍ରଶିକ୍ଷଣ ଯୋଗ",
  },
  footer: {
    eyebrow: "ପଞ୍ଜୀକୃତ ଟ୍ରଷ୍ଟ", line1: "ଓଡ଼ିଶାର କୃଷକଙ୍କ ପାଇଁ ପ୍ରତିଷ୍ଠିତ",
    about: "ପାରମ୍ପରିକ କୃଷି ଜ୍ଞାନର ପୁନର୍ଜୀବନ। ସ୍ଥାନୀୟ ବିହନର ସଂରକ୍ଷଣ। ଓଡ଼ିଶାର ପରବର୍ତ୍ତୀ ପିଢ଼ିର କୃଷକଙ୍କ ପ୍ରଶିକ୍ଷଣ।",
    explore: "ଦେଖନ୍ତୁ", get_in_touch: "ଯୋଗାଯୋଗ",
    credit: "ନିର୍ମିତ ଓ ପରିଚାଳିତ", admin: "ଆଡ୍ମିନ୍",
    rights: "ସମସ୍ତ ଅଧିକାର ସଂରକ୍ଷିତ।",
  },
  about_page: {
    eyebrow: "ଟ୍ରଷ୍ଟ ବିଷୟରେ",
    h1a: "ଲୋକ ସମବାୟ",
    h1b: "ପ୍ରତିଷ୍ଠାନ ବିଷୟରେ।",
    intro: "ଭାରତୀୟ ଟ୍ରଷ୍ଟ ଆକ୍ଟ ଅଧୀନରେ ପଞ୍ଜୀକୃତ ଏକ ଟ୍ରଷ୍ଟ, ଓଡ଼ିଶାରେ ଆଧାରିତ, ପ୍ରାକୃତିକ କୃଷି, କୃଷକ ଶିକ୍ଷା, ବିହନ ସୁରକ୍ଷା ଓ ସ୍ଥାୟୀ ଜୀବିକା ମାଧ୍ୟମରେ କୃଷିର ପରିବର୍ତ୍ତନ ପାଇଁ ପ୍ରତିବଦ୍ଧ।",
    quote: "\"ସୁସ୍ଥ ମାଟି ସୁସ୍ଥ ଖାଦ୍ୟ, ସୁସ୍ଥ ପରିବାର ଓ ସୁସ୍ଥ ଦେଶ ସୃଷ୍ଟି କରେ।\"",
    quote_by: "— LSP ମୂଳ ସିଦ୍ଧାନ୍ତ",
    vision_eyebrow: "ଆମର ଦୃଷ୍ଟିକୋଣ",
    vision_text: "ପାରମ୍ପରିକ ଜ୍ଞାନ ଉପରେ ନିର୍ମିତ ସମୃଦ୍ଧ, ଆତ୍ମନିର୍ଭର ଗ୍ରାମୀଣ ସମୁଦାୟ।",
    mission_eyebrow: "ଆମର ଲକ୍ଷ୍ୟ",
    m1: "ଓଡ଼ିଶା ସାରା ପ୍ରାକୃତିକ କୃଷିର ପ୍ରଚାର",
    m2: "ରାସାୟନିକ ସାର ଓ କୀଟନାଶକ ନିର୍ଭରତା କମାଇବା",
    m3: "ସ୍ଥାନୀୟ ବିହନର ବିବିଧତା ସୁରକ୍ଷା",
    m4: "କୃଷକ ଆୟ ବୃଦ୍ଧି",
    m5: "ଗ୍ରାମୀଣ ଯୁବକଙ୍କୁ କୃଷିରେ ପ୍ରଶିକ୍ଷଣ",
    m6: "କୃଷି ସମୁଦାୟର ମହିଳାମାନଙ୍କୁ ସମର୍ଥନ",
    values_eyebrow: "ଆମର ମୂଲ୍ୟବୋଧ", values_h2: "ଅଟଳ।",
    v1_title: "ସ୍ଥିରତା", v1_text: "ପ୍ରତ୍ୟେକ ଅଭ୍ୟାସ ଆମକୁ ଶହେ ଋତୁରୁ ଅଧିକ ସମୟ ଯାଏଁ ଟିକିବ।",
    v2_title: "କୃଷକ ପ୍ରଥମେ", v2_text: "ନିଷ୍ପତ୍ତି କୃଷକ କ୍ଷେତ୍ରରେ ନିଆଯାଏ, ବୋର୍ଡ ରୁମରେ ନୁହେଁ।",
    v3_title: "ସମୁଦାୟ ଅଭିବୃଦ୍ଧି", v3_text: "ଯେତେବେଳେ ଗୋଟିଏ ଗାଁ ସଫଳ ହୁଏ, ଆମେ ସଫଳ ହୁଏ — ଏକାଠି।",
    v4_title: "ସ୍ୱଚ୍ଛତା", v4_text: "ଖୋଲା ରେକର୍ଡ, ଖୋଲା କ୍ଷେତ୍ର, ଖୋଲା କଥାବାର୍ତ୍ତା।",
    v5_title: "ମାଟିର ସ୍ୱାସ୍ଥ୍ୟ", v5_text: "ସୁସ୍ଥ ମାଟି ସୁସ୍ଥ ଦେଶର ମୂଳଦୁଆ।",
    serves_eyebrow: "ଆମେ କାହାକୁ ସେବା କରୁ", serves_h2: "ପ୍ରତ୍ୟେକ ଅମଳ ପଛର ଲୋକ।",
    serves: ["କ୍ଷୁଦ୍ର କୃଷକ", "ସୀମାନ୍ତ କୃଷକ", "ବ୍ୟାଟାଇ କୃଷକ", "ମହିଳା କୃଷକ", "ଗ୍ରାମୀଣ ଯୁବକ", "କୃଷକ ଗୋଷ୍ଠୀ"],
  },
  services_page: {
    eyebrow: "ଆମର କାର୍ଯ୍ୟ · ସେବାଗୁଡ଼ିକ",
    h1a: "ଆମର ସେବା ଓ",
    h1b: "ମୂଳ କାର୍ଯ୍ୟକଳାପ।",
    intro: "ମାଟିଠାରୁ ଗ୍ରାମୀଣ ଅର୍ଥନୀତି ପୁନଃନିର୍ମାଣ ପାଇଁ ଛଅଟି ପାରସ୍ପରିକ ଯୋଜନା।",
    blocks: [
      { title: "ପ୍ରାକୃତିକ କୃଷି ସଲାହ", points: ["ମାଟି ପୁନଃସ୍ଥାପନ", "ରାସାୟନିକ-ମୁକ୍ତ କୃଷି", "ମଲ୍ଚିଂ ପଦ୍ଧତି", "ଫସଲ ବିବିଧତା", "କମ୍ ଇନପୁଟ୍ ଚାଷ"] },
      { title: "ସ୍ଥାନୀୟ ବିହନ ସଂରକ୍ଷଣ", intro: "ସ୍ଥାନୀୟ ଜଳବାୟୁ ଓ ଉନ୍ନତ ପୋଷଣ ପାଇଁ ଉପଯୁକ୍ତ ପାରମ୍ପରିକ ପ୍ରକାର।", points: ["ଚାଉଳ ବିହନ", "ଡାଲି", "ପନିପରିବା", "ତେଲ ବିହନ"] },
      { title: "ଜୈବିକ ଇନପୁଟ୍ ଓ ପ୍ରାକୃତିକ ଫର୍ମୁଲା", points: ["ଜୀବାମୃତ", "କମ୍ପୋଷ୍ଟ", "ଭର୍ମିକମ୍ପୋଷ୍ଟ", "ତରଳ ସାର", "ପ୍ରାକୃତିକ କୀଟନାଶକ"] },
      { title: "କୃଷକ କ୍ଷମତା ନିର୍ମାଣ", points: ["ଗାଁ ପ୍ରଶିକ୍ଷଣ ଶିବିର", "ଦର୍ଶନୀୟ ପ୍ଲଟ୍", "ଦର୍ଶନ ଯାତ୍ରା", "ଋତୁଗତ ମାର୍ଗଦର୍ଶନ"] },
      { title: "ସହାୟକ କୃଷି ଯୋଜନା", intro: "ଧାନ ଋତୁ ବାହାରେ ଆୟର ବିବିଧୀକରଣ।", points: ["ଦୁଗ୍ଧ ଚାଷ", "କୁକୁଡ଼ା ଚାଷ", "ମତ୍ସ୍ୟ ଚାଷ", "ମହୁମାଛି ପାଳନ"] },
      { title: "ଗ୍ରାମୀଣ ବିପଣନ ସମର୍ଥନ", points: ["ସିଧା-ଗ୍ରାହକ", "ସହର କ୍ରେତା ନେଟୱାର୍କ", "ସମବାୟ ବ୍ରାଣ୍ଡିଂ", "ଅନୁଷ୍ଠାନିକ ଯୋଗାଣ"] },
    ],
    cta: "ଆପଣଙ୍କ ଗାଁ କିମ୍ବା ସଂସ୍ଥା ସହ କାମ କରିବାକୁ ଚାହୁଁଛନ୍ତି?",
    cta_btn: "ଚାଲନ୍ତୁ କଥା ହୋଇବା",
  },
  training_page: {
    eyebrow: "ପ୍ରଶିକ୍ଷଣ କାର୍ଯ୍ୟକ୍ରମ",
    h1a: "ଓଡ଼ିଶାରେ ପ୍ରାକୃତିକ",
    h1b: "କୃଷି ପ୍ରଶିକ୍ଷଣ।",
    intro: "ବ୍ୟାବହାରିକ, କ୍ଷେତ୍ର-ଆଧାରିତ ମଡ୍ୟୁଲ୍ — ପ୍ରାରମ୍ଭିକ ମୂଳିକାଠାରୁ ଲାଭଦାୟକ ପ୍ରାକୃତିକ କୃଷି ଚଲାଇବା ଯାଏଁ।",
    l1_tag: "ମୂଳ", l1_title: "ପ୍ରାକୃତିକ କୃଷିର ମୂଳଦୁଆ",
    l1_topics: ["ମାଟି ସ୍ୱାସ୍ଥ୍ୟ ମୂଳ", "ବିହନ ଚିକିତ୍ସା", "କମ୍ପୋଷ୍ଟିଂ", "ଜୀବାମୃତ ପରିଚୟ"],
    l2_tag: "ମଧ୍ୟମ", l2_title: "ଏକ ପ୍ରାକୃତିକ କ୍ଷେତ୍ର ପରିଚାଳନା",
    l2_topics: ["ପ୍ରାକୃତିକ କୀଟ ନିୟନ୍ତ୍ରଣ", "ଫସଲ ଯୋଜନା", "ଜଳ ପରିଚାଳନା", "ମିଶ୍ର ଚାଷ"],
    l3_tag: "ଉନ୍ନତ", l3_title: "ପ୍ରାକୃତିକ କ୍ଷେତ୍ରକୁ ଏକ ବ୍ୟବସାୟ ଭାବେ",
    l3_topics: ["କ୍ଷେତ୍ର ବ୍ୟବସାୟ ମଡେଲ୍", "ମୂଲ୍ୟ ଯୋଗ", "ସିଧା ବିକ୍ରୟ", "ସାର୍ଟିଫିକେସନ୍ ଓ ବ୍ରାଣ୍ଡିଂ"],
    who_eyebrow: "କିଏ ଅଂଶଗ୍ରହଣ କରିପାରିବ",
    who_h2a: "ଯେକେହି",
    who_h2b: "ଜମି ସହ କାମ କରିବାକୁ ଚାହୁଁଥିବା।",
    audience: ["କୃଷକ", "କୃଷି ଛାତ୍ର", "ଏନଜିଓ ଓ ସଂସ୍ଥା", "ଗ୍ରାମୀଣ ଉଦ୍ୟୋଗୀ", "କୃଷିରେ ପ୍ରବେଶ କରୁଥିବା ଯୁବକ", "ସରକାରୀ ଅଧିକାରୀ"],
    modes_eyebrow: "ପ୍ରଶିକ୍ଷଣ ମାଧ୍ୟମ",
    modes_h2a: "ସବୁକିଛି",
    modes_h2b: "କେଉଁଠି ଘଟେ।",
    modes: ["କ୍ଷେତ୍ର ପ୍ରଶିକ୍ଷଣ", "ଗୋଷ୍ଠୀ କର୍ମଶାଳା", "ଅନୁଷ୍ଠାନିକ ଅଧିବେଶନ", "ପେଶାଦାର ମଡ୍ୟୁଲ୍"],
    cta_title: "ଆଜି ଏକ ପ୍ରଶିକ୍ଷଣ ସେସନ୍ ବୁକ୍ କରନ୍ତୁ।",
    cta_btn: "ଏକ ସ୍ଲଟ୍ ଅନୁରୋଧ କରନ୍ତୁ",
  },
  products_page: {
    eyebrow: "ପ୍ରାକୃତିକ କୃଷି ଉତ୍ପାଦ",
    h1a: "ଆମର କ୍ଷେତ୍ରରୁ",
    h1b: "ଆପଣଙ୍କ ରୋଷେଇଘରକୁ।",
    intro: "LSP ସମର୍ଥିତ କ୍ଷେତ୍ରରୁ ମୂଲ୍ୟ ଯୁକ୍ତ ଉତ୍ପାଦ। ଖୁଚୁରା ଓ ସଂସ୍ଥା ବଲ୍କ ଅର୍ଡର ପାଇଁ ଉପଲବ୍ଧ।",
    items: [
      { name: "ସ୍ଥାନୀୟ ଚାଉଳ", tag: "ମୁଖ୍ୟ", desc: "ପାରମ୍ପରିକ ଓଡ଼ିଆ ପ୍ରକାର — ପୋଷଣ ଭରପୂର ଓ ରାସାୟନିକ ବିନା।" },
      { name: "ଡାଲି", tag: "ପ୍ରୋଟିନ୍", desc: "ଆରହର, ମୁଗ, ବିରି ଓ କୁଳ୍ଥି ଘୂର୍ଣ୍ଣନ କ୍ଷେତ୍ରରୁ।" },
      { name: "ଋତୁଗତ ପନିପରିବା", tag: "ତାଜା", desc: "କ୍ଷେତ୍ରରୁ କଟା, ଋତୁ-ଯୁକ୍ତ, ଶୂନ୍ୟ ଅବଶେଷ।" },
      { name: "ମଧୁ", tag: "ମହୁମାଛି", desc: "LSP ମହୁପାଳକ ଗୋଷ୍ଠୀର ବହୁ-ପୁଷ୍ପ ମଧୁ।" },
      { name: "A2 ଗୋ ଘୃତ", tag: "ଦୁଗ୍ଧ", desc: "ଧୀର ଭାବେ ମନ୍ଥନ, ପାରମ୍ପରିକ ବିଲୋନା ପଦ୍ଧତି।" },
      { name: "ତାଜା ମାଛ", tag: "ମତ୍ସ୍ୟ", desc: "LSP ସମର୍ଥିତ ପ୍ରାକୃତିକ ମାଛ କ୍ଷେତ୍ରରୁ।" },
      { name: "ଜୀବାମୃତ ଓ ଜୈବିକ", tag: "ଜୈବିକ", desc: "କ୍ଷେତ୍ରରେ ପ୍ରସ୍ତୁତ ଜୈବିକ — ବ୍ୟବହାର ପାଇଁ ପ୍ରସ୍ତୁତ।" },
      { name: "ସାର", tag: "ମାଟି", desc: "ମାଟି ପୁନଃନିର୍ମାଣ ପାଇଁ କମ୍ପୋଷ୍ଟ ଓ ଭର୍ମିକମ୍ପୋଷ୍ଟ।" },
    ],
    bulk_eyebrow: "ବଲ୍କ ଓ ଅନୁଷ୍ଠାନିକ",
    bulk_title: "ଓଡ଼ିଶା ସାରା ହୋଷ୍ଟେଲ, କାଫେ ଓ ସହର ଷ୍ଟୋରକୁ ଯୋଗାଣ।",
    enquire_dialog_title: "ଏହି ବିଷୟରେ ଅନୁସନ୍ଧାନ",
    enquire_dialog_desc: "ଆପଣଙ୍କ ବିବରଣୀ ଭାଗ କରନ୍ତୁ — ଆମ ଟିମ୍ ହ୍ୱାଟ୍ସଆପ୍ କିମ୍ବା ଫୋନ୍ରେ ଯୋଗାଯୋଗ କରିବ।",
  },
  gallery_page: {
    eyebrow: "ଗ୍ୟାଲେରୀ",
    h1a: "କ୍ଷେତ୍ର ଟିପ୍ପଣୀ,",
    h1b: "ଫଟୋରେ।",
    intro: "ପ୍ରଶିକ୍ଷଣ ଶିବିର, କୃଷକ ସଭା, ବିହନ ସଂଗ୍ରହ, ଆମର କ୍ଷେତ୍ର, ଉତ୍ପାଦ ଓ ସମ୍ପ୍ରଦାୟ।",
  },
  blog_page: {
    eyebrow: "ଜର୍ନାଲ୍ · କ୍ଷେତ୍ର ନୋଟ୍",
    h1a: "କ୍ଷେତ୍ରରୁ",
    h1b: "କାହାଣୀ।",
    empty: "ଏବେଯାଏଁ କୌଣସି ପୋଷ୍ଟ ନାହିଁ।",
  },
  contact_page: {
    eyebrow: "ଯୋଗାଯୋଗ",
    h1a: "ଚାଲନ୍ତୁ ଚାଷ ବିଷୟରେ",
    h1b: "କଥା ହୁଅନ୍ତୁ।",
    chairman_label: "ଅଧ୍ୟକ୍ଷ",
    chairman_name: "ସୁବାସ ଚନ୍ଦ୍ର ସାହୁ",
    phone_label: "ଫୋନ୍",
    email_label: "ଇମେଲ୍",
    address_label: "ଠିକଣା",
    address: "ନିଆଳି, କଟକ\nଭୁବନେଶ୍ୱର — ୭୫୧୦୨୧\nଓଡ଼ିଶା, ଭାରତ",
    form_title: "ଆମକୁ ଏକ ବାର୍ତ୍ତା ପଠାନ୍ତୁ।",
    form_sub: "ଆମେ ସାଧାରଣତଃ ୨୪ ଘଣ୍ଟା ମଧ୍ୟରେ ଉତ୍ତର ଦେଉ।",
    form_success: "ବାର୍ତ୍ତା ପଠାଗଲା। ଆମେ ଶୀଘ୍ର ଯୋଗାଯୋଗ କରିବୁ!",
    form_error_required: "ନାମ, ଫୋନ୍ ଓ ବାର୍ତ୍ତା ଆବଶ୍ୟକ",
  },
};

const hi = {
  meta: {
    site_name: "लोक समबाय प्रतिष्ठान",
    tagline: "प्राकृतिक खेती ट्रस्ट · ओडिशा",
    home: { title: "ओडिशा का प्राकृतिक खेती ट्रस्ट | लोक समबाय प्रतिष्ठान", desc: "ओडिशा का पंजीकृत ट्रस्ट — प्राकृतिक खेती, किसान प्रशिक्षण, देशी बीज और टिकाऊ ग्रामीण विकास। मुफ्त प्रशिक्षण। 2,000+ किसान।", kw: "ओडिशा में प्राकृतिक खेती, किसान सहायता ओडिशा, जैविक खेती प्रशिक्षण, LSP ट्रस्ट" },
    about: { title: "LSP के बारे में | ओडिशा किसान NGO व ग्रामीण विकास", desc: "लोक समबाय प्रतिष्ठान कटक के नियाली में स्थित एक पंजीकृत ट्रस्ट है जो प्राकृतिक खेती और बीज संरक्षण के माध्यम से किसानों को सशक्त बनाता है।", kw: "ओडिशा किसान NGO, ग्रामीण विकास, कटक किसान ट्रस्ट" },
    services: { title: "हमारा कार्य — प्राकृतिक खेती व बीज कार्यक्रम | LSP ओडिशा", desc: "छह मुख्य कार्यक्रम — प्राकृतिक खेती सलाह, देशी बीज संरक्षण, जैविक इनपुट, किसान प्रशिक्षण, सहायक कृषि और ग्रामीण बाजार।", kw: "ओडिशा प्राकृतिक खेती सेवा, देशी बीज, जैविक इनपुट" },
    training: { title: "ओडिशा में मुफ्त खेती प्रशिक्षण | किसानों के लिए कार्यशाला", desc: "ओडिशा के गांवों में मुफ्त, व्यावहारिक प्राकृतिक खेती प्रशिक्षण। बुनियादी, मध्यम और उन्नत मॉड्यूल।", kw: "ओडिशा खेती प्रशिक्षण, जैविक खेती कार्यशाला, मुफ्त किसान तालीम" },
    products: { title: "प्राकृतिक कृषि उत्पाद | चावल, दाल, शहद, घी — LSP ओडिशा", desc: "LSP समर्थित प्राकृतिक खेतों से रसायन-मुक्त चावल, दाल, सब्जियाँ, शहद, A2 गो घी और बायो-इनपुट।", kw: "ओडिशा प्राकृतिक उत्पाद, जैविक चावल, A2 गो घी" },
    gallery: { title: "गैलरी — किसान प्रशिक्षण, खेत और उत्पाद | LSP ओडिशा", desc: "LSP गांव शिविर, किसान सभा, बीज संग्रह और प्राकृतिक खेती की तस्वीरें।", kw: "किसान प्रशिक्षण फोटो, ओडिशा गांव खेती" },
    blog: { title: "ब्लॉग — प्राकृतिक खेती सुझाव व किसान कहानियाँ | LSP", desc: "प्राकृतिक खेती सुझाव, देशी बीज गाइड, लागत कम करने के तरीके और ओडिशा के किसानों की कहानियाँ।", kw: "ओडिशा प्राकृतिक खेती ब्लॉग" },
    contact: { title: "लोक समबाय प्रतिष्ठान संपर्क | नियाली, कटक, ओडिशा", desc: "फोन +91 99380 56120 · नियाली, कटक, ओडिशा।", kw: "LSP ओडिशा संपर्क" },
  },
  nav: { home: "होम", about: "परिचय", services: "हमारा कार्य", training: "प्रशिक्षण", products: "उत्पाद", gallery: "गैलरी", blog: "ब्लॉग", contact: "संपर्क", get_in_touch: "संपर्क करें" },
  common: {
    call_us: "कॉल करें +91 99380 56120",
    read_more: "और पढ़ें", learn_more: "और जानें", explore: "देखें",
    enquire_now: "पूछताछ करें",
    send: "भेजें", sending: "भेजा जा रहा है…",
    name: "नाम", phone: "फोन", whatsapp: "व्हाट्सएप नंबर", email: "ईमेल", message: "संदेश",
    our_full_story: "हमारी पूरी कहानी",
    view_all_programs: "सभी कार्यक्रम देखें",
    all_articles: "सभी लेख",
    voices: "खेत से आवाज़ें",
    loading: "लोड हो रहा है…",
  },
  hero: {
    eyebrow: "पंजीकृत ट्रस्ट · ओडिशा, भारत",
    h1a: "ज़्यादा फसल।",
    h1b: "कम खर्च।",
    h1c: "दादा-परदादा की तरह खेती।",
    sub_before: "लोक समबाय प्रतिष्ठान ने",
    sub_bold: "ओडिशा के 2,000+ किसानों",
    sub_after: "को रसायनों की लागत कम करने, मिट्टी को वापस जिंदा करने और ज़्यादा कमाने में मदद की है — प्राकृतिक खेती, देशी बीज और मुफ्त गांव-स्तरीय प्रशिक्षण के जरिए।",
    cta_call: "कॉल करें +91 99380 56120",
    cta_training: "मुफ्त प्रशिक्षण जुड़ें",
    cta_work: "हमारा कार्य देखें",
    tagline: "किसानों के लिए मुफ्त · कोई फीस नहीं · आपकी भाषा में · आपके खेत पर",
    scroll: "स्क्रॉल · ओडिशा",
  },
  trust: {
    b1_label: "पंजीकृत ट्रस्ट", b1_sub: "भारतीय ट्रस्ट अधिनियम के तहत",
    b2_label: "2,000+ किसान", b2_sub: "6 जिलों में",
    b3_label: "120+ बीज प्रकार", b3_sub: "संरक्षित और मुफ्त साझा",
    b4_label: "किसानों द्वारा निर्मित", b4_sub: "हमारे अध्यक्ष के नेतृत्व में",
  },
  problem: {
    eyebrow: "हमारी समस्या",
    h2a: "ओडिशा में खेती",
    h2b: "पहले से कठिन है।",
    lead: "हर किसान हमें यही चार बातें बताता है:",
    p1_title: "रसायनों की बढ़ती लागत", p1_text: "उर्वरक और कीटनाशक बिल हर फसल की आधी आय खा जाते हैं।",
    p2_title: "मिट्टी मर रही है", p2_text: "सालों के रसायनों ने खेतों को सूखा, कठोर और बेजान छोड़ दिया।",
    p3_title: "पैदावार घट रही है", p3_text: "वही जमीन। वही मेहनत। कम फसल — मौसम दर मौसम।",
    p4_title: "कोई मार्गदर्शन नहीं", p4_text: "कोई पूछने वाला नहीं। कोई आपकी भाषा में नहीं।",
    answer_eyebrow: "हमारा जवाब",
    answer: "दादा-परदादा के ज्ञान को वापस लाओ — और आधुनिक, खेत-परीक्षित विज्ञान के साथ जोड़ो।",
    learn_more: "हम कैसे करते हैं",
  },
  how: {
    eyebrow: "कैसे काम करता है",
    h2a: "तीन कदम।",
    h2b: "कोई फीस नहीं। कोई फॉर्म नहीं।",
    s1_title: "कॉल करें या आइए", s1_text: "+91 99380 56120 पर एक फोन। कोई फॉर्म, कोई फीस नहीं। हम आपको नज़दीकी गांव शिविर में बुलाएंगे।",
    s2_title: "अपने खेत पर सीखें", s2_text: "आपकी भाषा में हाथों-हाथ प्रशिक्षण — जीवामृत, खाद, बीज बचत, फसल योजना। क्लासरूम नहीं, आपका खेत।",
    s3_title: "प्राकृतिक रूप से उगाएं", s3_text: "एक प्लॉट से शुरू करें। पूरे मौसम हम साथ रहते हैं। ज्यादातर किसान पहली फसल में ही फर्क देखते हैं।",
    cta_call: "एक कॉल से शुरू करें",
    note: "हमारे कोऑर्डिनेटर से ओडिया, हिंदी या अंग्रेज़ी में बात करें — जो आपको आसान लगे।",
  },
  about_short: {
    eyebrow: "ट्रस्ट के बारे में",
    h2a: "जनता का ट्रस्ट,",
    h2b: "कंपनी नहीं।",
    p1: "LSP नियाली, कटक में स्थित एक पंजीकृत ट्रस्ट है। हमारा काम शुभचिंतकों, हमारे खेतों और किसान सहकारी समितियों से पोषित होता है — शेयरधारकों से नहीं। हर रुपया किसानों, बीजों और प्रशिक्षण शिविरों में वापस जाता है।",
    p2: "स्वस्थ मिट्टी स्वस्थ भोजन, स्वस्थ परिवार और स्वस्थ राष्ट्र बनाती है।",
  },
  services_home: {
    eyebrow: "हम क्या करते हैं",
    h2a: "एक गांव बदलने के",
    h2b: "छह शांत तरीके।",
    lead: "हर कार्यक्रम खेत-परीक्षित, किसान-नेतृत्व वाला है, और मौसम के अंत में एक परिवार के पास बची आय से मापा जाता है।",
    s1_title: "प्राकृतिक खेती", s1_text: "कम लागत, रसायन-मुक्त, पर्यावरण-अनुकूल प्रणालियाँ जो ज़मीन को पुनर्जीवित करती हैं।",
    s2_title: "देशी बीज", s2_text: "पारंपरिक चावल, दाल, सब्जी और तेल बीज का संरक्षण व वितरण।",
    s3_title: "किसान प्रशिक्षण", s3_text: "किसानों, छात्रों व ग्रामीण संस्थाओं के लिए हाथों-हाथ कार्यशाला।",
    s4_title: "सहायक आजीविका", s4_text: "मत्स्य, डेयरी, पोल्ट्री, मधुमक्खी पालन — ग्रामीण आय में विविधता।",
    s5_title: "बाजार जुड़ाव", s5_text: "किसानों को सीधे शहरी ग्राहकों व संस्थाओं से जोड़ना।",
    s6_title: "सामुदायिक विकास", s6_text: "महिला समूह, ग्रामीण युवा व गांव सहकारी।",
  },
  impact: {
    eyebrow: "प्रभाव",
    h2a: "बढ़ता बदलाव",
    h2b: "पूरे ओडिशा में।",
    i1: "समर्थित किसान", i2: "देशी बीज प्रकार", i3: "प्रति वर्ष प्रशिक्षण शिविर", i4: "पहुँचे हुए जिले",
    where_title: "हम कंधे से कंधा मिलाकर काम करते हैं:",
  },
  testimonials_home: {
    h2a: "किसान हमें",
    h2b: "क्या कहते हैं।",
    t1_q: "पहले मौसम में रसायनों की लागत आधी हो गई। बचत देख मेरी पत्नी रो पड़ी।", t1_by: "राजेश · नियाली",
    t2_q: "LSP ने सिखाया कि दादा-परदादा के बीज किसी कंपनी से बेहतर हैं। हम वापस उगा रहे हैं।", t2_by: "किसान समूह · कटक",
    t3_q: "मैं खेती छोड़ने को तैयार था। प्राकृतिक खेती ने गांव में रुकने की वजह दी।", t3_by: "भगवान · ढेंकानाल",
    t4_q: "प्रशिक्षण मुफ्त था, और वे पूरे मौसम हमारे साथ रहे। ऐसा कौन करता है?", t4_by: "सुनीता · खोरधा",
    t5_q: "हमारा देशी धान भुवनेश्वर में दोगुने दाम पर बिका। LSP ने यह कर दिखाया।", t5_by: "किसान सहकारी · भुवनेश्वर",
  },
  faq_home: {
    eyebrow: "किसान पूछते हैं",
    h2a: "जो जानना है,",
    h2b: "सीधी भाषा में जवाब।",
    items: [
      { q: "लोक समबाय प्रतिष्ठान क्या है?", a: "LSP ओडिशा का एक पंजीकृत ट्रस्ट है जो प्राकृतिक खेती, देशी बीज संरक्षण, किसान प्रशिक्षण और ग्रामीण आजीविका को बढ़ावा देता है। हम नियाली, कटक में स्थित हैं।" },
      { q: "क्या प्रशिक्षण किसानों के लिए मुफ्त है?", a: "हाँ। सभी गांव स्तरीय प्रशिक्षण शिविर और क्षेत्र प्रदर्शन किसानों के लिए पूरी तरह मुफ्त हैं।" },
      { q: "क्या मुझे LSP से देशी बीज मिल सकते हैं?", a: "हाँ — उपलब्धता के आधार पर। हम पारंपरिक चावल, दाल, सब्जी और तेल बीज साझा करते हैं।" },
      { q: "LSP किन जिलों में काम करता है?", a: "हम नियाली, कटक, भुवनेश्वर, खोरधा, ढेंकानाल और पास के ग्रामीण क्षेत्रों में सक्रिय हैं।" },
      { q: "प्रशिक्षण कार्यक्रम में कैसे जुड़ें?", a: "बस +91 99380 56120 पर कॉल करें या व्हाट्सएप पर संदेश भेजें। हम आपको अगले बैच में जोड़ देंगे।" },
      { q: "क्या प्राकृतिक खेती पहले साल में आय घटाएगी?", a: "ज्यादातर किसान पहले मौसम से ही रसायन लागत 50-70% तक घटी देखते हैं। 2 मौसम में पैदावार स्थिर हो जाती है।" },
    ],
  },
  final_cta: {
    h2a: "आपका खेत हकदार है",
    h2b: "एक बेहतर मौसम का।",
    lead: "कॉल करें। शिविर आएं। दोस्त लाएं। पहला कदम मुफ्त है — और यही सब बदल देता है।",
    cta_call: "कॉल करें +91 99380 56120",
    cta_msg: "संदेश भेजें", cta_train: "प्रशिक्षण",
  },
  footer: {
    eyebrow: "पंजीकृत ट्रस्ट", line1: "ओडिशा के किसानों के लिए स्थापित",
    about: "पारंपरिक खेती ज्ञान का पुनरुद्धार। देशी बीजों का संरक्षण। ओडिशा के अगली पीढ़ी के किसानों का प्रशिक्षण।",
    explore: "देखें", get_in_touch: "संपर्क",
    credit: "निर्मित व प्रबंधित", admin: "एडमिन",
    rights: "सर्वाधिकार सुरक्षित।",
  },
  about_page: {
    eyebrow: "ट्रस्ट के बारे में",
    h1a: "लोक समबाय",
    h1b: "प्रतिष्ठान के बारे में।",
    intro: "भारतीय ट्रस्ट अधिनियम के तहत पंजीकृत, ओडिशा में स्थित एक ट्रस्ट, जो प्राकृतिक खेती, किसान शिक्षा, देशी बीज सुरक्षा और टिकाऊ आजीविका के माध्यम से कृषि को बदलने के लिए प्रतिबद्ध है।",
    quote: "\"स्वस्थ मिट्टी स्वस्थ भोजन, स्वस्थ परिवार और स्वस्थ राष्ट्र बनाती है।\"",
    quote_by: "— LSP संस्थापक सिद्धांत",
    vision_eyebrow: "हमारी दृष्टि",
    vision_text: "पारंपरिक ज्ञान पर आधारित समृद्ध, आत्मनिर्भर ग्रामीण समुदाय।",
    mission_eyebrow: "हमारा मिशन",
    m1: "ओडिशा भर में प्राकृतिक खेती को बढ़ावा",
    m2: "रासायनिक उर्वरक व कीटनाशक निर्भरता कम करना",
    m3: "देशी बीज विविधता की रक्षा",
    m4: "किसान आय बढ़ाना",
    m5: "ग्रामीण युवाओं को कृषि में प्रशिक्षित करना",
    m6: "किसान समुदाय की महिलाओं का समर्थन",
    values_eyebrow: "हमारे मूल्य", values_h2: "अटल।",
    v1_title: "स्थिरता", v1_text: "हर अभ्यास हमसे सौ मौसम से ज्यादा चलना चाहिए।",
    v2_title: "किसान पहले", v2_text: "निर्णय किसान खेतों में लिए जाते हैं, बोर्डरूम में नहीं।",
    v3_title: "सामुदायिक विकास", v3_text: "जब एक गांव सफल होता है तो हम सफल होते हैं — एक साथ।",
    v4_title: "पारदर्शिता", v4_text: "खुले रिकॉर्ड, खुले खेत, खुली बातें।",
    v5_title: "मिट्टी का स्वास्थ्य", v5_text: "स्वस्थ मिट्टी स्वस्थ राष्ट्रों की नींव है।",
    serves_eyebrow: "हम किसकी सेवा करते हैं", serves_h2: "हर फसल के पीछे के लोग।",
    serves: ["छोटे किसान", "सीमांत किसान", "बटाईदार", "महिला किसान", "ग्रामीण युवा", "किसान समूह"],
  },
  services_page: {
    eyebrow: "हमारा कार्य · सेवाएँ",
    h1a: "हमारी सेवाएँ व",
    h1b: "मुख्य गतिविधियाँ।",
    intro: "मिट्टी से ग्रामीण अर्थव्यवस्था के पुनर्निर्माण के लिए छह परस्पर जुड़े कार्यक्रम।",
    blocks: [
      { title: "प्राकृतिक खेती सलाह", points: ["मिट्टी की बहाली", "रसायन-मुक्त खेती", "मल्चिंग विधि", "फसल विविधता", "कम-इनपुट खेती"] },
      { title: "देशी बीज संरक्षण", intro: "स्थानीय जलवायु और बेहतर पोषण के लिए उपयुक्त पारंपरिक किस्में।", points: ["चावल बीज", "दालें", "सब्जियाँ", "तेल बीज"] },
      { title: "जैविक इनपुट व प्राकृतिक फार्मूला", points: ["जीवामृत", "खाद", "वर्मीकम्पोस्ट", "तरल खाद", "प्राकृतिक कीटनाशक"] },
      { title: "किसान क्षमता निर्माण", points: ["गांव प्रशिक्षण शिविर", "प्रदर्शन प्लॉट", "प्रदर्शन यात्राएँ", "मौसमी मार्गदर्शन"] },
      { title: "सहायक कृषि कार्यक्रम", intro: "धान के मौसम से परे आय का विविधीकरण।", points: ["डेयरी", "पोल्ट्री", "मत्स्य", "मधुमक्खी पालन"] },
      { title: "ग्रामीण विपणन सहायता", points: ["सीधे उपभोक्ता", "शहरी खरीदार नेटवर्क", "सहकारी ब्रांडिंग", "संस्थागत आपूर्ति"] },
    ],
    cta: "अपने गांव या संस्था के साथ हमें काम पर रखना चाहते हैं?",
    cta_btn: "चलिए बात करें",
  },
  training_page: {
    eyebrow: "प्रशिक्षण कार्यक्रम",
    h1a: "ओडिशा में प्राकृतिक",
    h1b: "खेती प्रशिक्षण।",
    intro: "व्यावहारिक, खेत-आधारित मॉड्यूल — शुरुआती बुनियादी बातों से लेकर लाभदायक प्राकृतिक खेत चलाने तक।",
    l1_tag: "बुनियादी", l1_title: "प्राकृतिक खेती की बुनियाद",
    l1_topics: ["मिट्टी स्वास्थ्य मूल", "बीज उपचार", "खाद बनाना", "जीवामृत परिचय"],
    l2_tag: "मध्यम", l2_title: "प्राकृतिक खेत का प्रबंधन",
    l2_topics: ["प्राकृतिक कीट नियंत्रण", "फसल योजना", "जल प्रबंधन", "मल्चिंग व मिश्रित खेती"],
    l3_tag: "उन्नत", l3_title: "प्राकृतिक खेत को व्यवसाय के रूप में",
    l3_topics: ["खेत व्यवसाय मॉडल", "मूल्य संवर्धन", "सीधे बिक्री के तरीके", "प्रमाणन व ब्रांडिंग"],
    who_eyebrow: "कौन शामिल हो सकता है",
    who_h2a: "जो भी",
    who_h2b: "ज़मीन से काम करने को तैयार है।",
    audience: ["किसान", "कृषि छात्र", "NGO व संस्थाएँ", "ग्रामीण उद्यमी", "खेती में कदम रख रहे युवा", "सरकारी विस्तार कार्यकर्ता"],
    modes_eyebrow: "प्रशिक्षण के तरीके",
    modes_h2a: "यह सब",
    modes_h2b: "कहाँ होता है।",
    modes: ["खेत पर प्रशिक्षण", "समूह कार्यशाला", "संस्थागत सत्र", "पेशेवर भुगतान मॉड्यूल"],
    cta_title: "आज एक प्रशिक्षण सत्र बुक करें।",
    cta_btn: "एक स्लॉट मांगें",
  },
  products_page: {
    eyebrow: "प्राकृतिक कृषि उत्पाद",
    h1a: "हमारे खेतों से",
    h1b: "आपकी रसोई तक।",
    intro: "LSP समर्थित खेतों से मूल्य वर्धित उत्पाद। खुदरा व संस्थागत बल्क ऑर्डर उपलब्ध।",
    items: [
      { name: "देशी चावल", tag: "मुख्य", desc: "पारंपरिक ओडिशा किस्में — पोषण भरपूर, बिना रसायन।" },
      { name: "दालें", tag: "प्रोटीन", desc: "अरहर, मूंग, उड़द व कुल्थी घूर्णी खेतों से।" },
      { name: "मौसमी सब्जियाँ", tag: "ताज़ा", desc: "खेत से कटी, मौसम अनुरूप, शून्य अवशेष।" },
      { name: "जंगली शहद", tag: "मधुमक्खी", desc: "LSP मधुमक्खी पालकों का बहु-पुष्प शहद।" },
      { name: "A2 गो घी", tag: "डेयरी", desc: "धीमी मथाई, पारंपरिक बिलोना विधि।" },
      { name: "ताज़ी मछली", tag: "मत्स्य", desc: "LSP समर्थित प्राकृतिक मछली खेतों से।" },
      { name: "जीवामृत व बायो", tag: "बायो", desc: "खेत पर तैयार बायो-स्टिमुलेंट।" },
      { name: "खाद", tag: "मिट्टी", desc: "मिट्टी पुनर्निर्माण के लिए खाद व वर्मीकम्पोस्ट।" },
    ],
    bulk_eyebrow: "बल्क व संस्थागत",
    bulk_title: "ओडिशा भर के हॉस्टल, कैफे व शहरी स्टोर को आपूर्ति।",
    enquire_dialog_title: "इसके बारे में पूछताछ",
    enquire_dialog_desc: "अपना विवरण साझा करें — हमारी टीम व्हाट्सएप या फोन पर संपर्क करेगी।",
  },
  gallery_page: {
    eyebrow: "गैलरी",
    h1a: "खेत की बातें,",
    h1b: "तस्वीरों में।",
    intro: "प्रशिक्षण शिविर, किसान सभा, बीज संग्रह, हमारे खेत, उत्पाद और समुदाय।",
  },
  blog_page: {
    eyebrow: "जर्नल · खेत नोट्स",
    h1a: "खेत से",
    h1b: "कहानियाँ।",
    empty: "अभी तक कोई पोस्ट नहीं।",
  },
  contact_page: {
    eyebrow: "संपर्क",
    h1a: "चलिए खेती पर",
    h1b: "बात करें।",
    chairman_label: "अध्यक्ष",
    chairman_name: "सुबास चंद्र साहू",
    phone_label: "फोन",
    email_label: "ईमेल",
    address_label: "पता",
    address: "नियाली, कटक\nभुवनेश्वर — 751021\nओडिशा, भारत",
    form_title: "हमें संदेश भेजें।",
    form_sub: "हम आमतौर पर 24 घंटे में जवाब देते हैं।",
    form_success: "संदेश भेजा गया। हम जल्द संपर्क करेंगे!",
    form_error_required: "नाम, फोन और संदेश ज़रूरी हैं",
  },
};

const translations = { en, or, hi };

export const LANGS = [
  { code: "en", label: "English", native: "English" },
  { code: "or", label: "Odia", native: "ଓଡ଼ିଆ" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
];

export const DEFAULT_LANG = "en";

export function getTranslation(lang, path) {
  const parts = path.split(".");
  const pick = (dict) => {
    let node = dict;
    for (const p of parts) {
      if (node && typeof node === "object" && p in node) node = node[p];
      else return undefined;
    }
    return node;
  };
  const primary = pick(translations[lang] || translations[DEFAULT_LANG]);
  if (primary !== undefined) return primary;
  // fallback to English
  const fallback = pick(translations[DEFAULT_LANG]);
  return fallback !== undefined ? fallback : path;
}

export default translations;
